import { useEffect, useState } from 'react';
import { api, ApiError } from './api';
import { FIRM_NAME } from '../shared/firm';

export function RedeemApp() {
	const [status, setStatus] = useState('Opening your private questionnaire...');
	const [hasError, setHasError] = useState(false);
	useEffect(() => {
		const token = window.location.hash.slice(1);
		window.history.replaceState(null, '', '/c');
		if (!token) {
			setStatus(`This private link is incomplete. Please use the full link from ${FIRM_NAME}.`);
			setHasError(true);
			return;
		}
		void api<{ redirectTo: string }>('/api/client/redeem', { method: 'POST', body: JSON.stringify({ token }) })
			.then((result) => window.location.replace(result.redirectTo))
			.catch((error: unknown) => {
				setStatus(friendlyRedeemError(error));
				setHasError(true);
			});
	}, []);
	return (
		<main id="main" className="centered-panel">
			<h1>{FIRM_NAME} Estate Planning Questionnaire</h1>
			<p className={hasError ? 'save-status save-status-error' : 'save-status'} role={hasError ? 'alert' : 'status'}>
				{status}
			</p>
		</main>
	);
}

export function friendlyRedeemError(error: unknown): string {
	if (error instanceof ApiError && error.status === 410) {
		return `This private link is no longer valid. Ask ${FIRM_NAME} for a new link.`;
	}
	if (error instanceof ApiError && error.status === 503) return error.message;
	return `We couldn't open this private link. Check your internet connection and try again. If it still doesn't work, ask ${FIRM_NAME} for a new link.`;
}
